type MicrophoneParticipant={setMicrophoneEnabled:(enabled:boolean,options?:Record<string,unknown>)=>Promise<unknown>};
export function microphoneFailure(error:unknown){
 const e=error as Error;
 if(e?.name==='NotAllowedError'||e?.name==='SecurityError')return 'permission';
 if(e?.name==='NotFoundError'||e?.name==='OverconstrainedError')return 'missing';
 if(e?.name==='NotReadableError'||e?.name==='AbortError'||/could not start|audio source|in use/i.test(e?.message||''))return 'busy';
 return 'unknown';
}
// A missing saved device or an Android capture-start failure gets one bounded
// retry with the system device. Denied access is never retried automatically.
export async function setCallMicrophone(participant:MicrophoneParticipant,enabled:boolean,options:Record<string,unknown>,cancelled:()=>boolean=()=>false){
 try{await participant.setMicrophoneEnabled(enabled,options);return false}
 catch(error){
  if(!enabled||!['missing','busy'].includes(microphoneFailure(error))||cancelled())throw error;
  await participant.setMicrophoneEnabled(true,{...options,deviceId:'default'});
  return options.deviceId!=='default';
 }
}
// A failed publication has no live mic even when the requested mute flag is off.
export const microphoneToggleMuted=(published:boolean,muted:boolean,deafened:boolean)=>published&&!muted&&!deafened;
